import { Box, ScrollView, Text } from '@rbilabs/universal-components';

export const Form = ScrollView.withConfig({
  width: 'full',
});

export const Message = Text.withConfig({
  textAlign: 'center',
});

export const DefaultText = Text.withConfig({
  variant: 'copyOne',
  fontSize: 'sm',
  textTransform: 'uppercase',
  textAlign: 'right',
  marginRight: '$10',
});

export const DefaultTextWrapper = Box.withConfig({
  width: 'full',
  position: 'relative',
  height: '$6',
});
